import axios from './axios';
import { camelizeKeys, deserializeMoments, transformResponse } from '../util';
import { Config } from '../types';

export function getLeaderboards() {
    return axios.get<Config>(`/api/leaderboards`, {
        transformResponse: transformResponse(camelizeKeys, deserializeMoments),
    });
}
